import { render, staticRenderFns } from "./videoLabelList.vue?vue&type=template&id=209e0809&scoped=true&"
import script from "./videoLabelList.vue?vue&type=script&lang=js&"
export * from "./videoLabelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209e0809",
  null
  
)

component.options.__file = "videoLabelList.vue"
export default component.exports